module.exports = __webpack_public_path__ + "static/media/admin-portal.945f1878.png";